import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Image from 'next/image';
import { useStyles } from './style';
import { BLUR_DATA_URL } from '../../../util/imageConstants';
import { getRunTimeEnv } from '../../../util/getEnvVariable';

/**
 * @name ActionModalHeader - Action Modal Header
 * @param {object} props - CMS data from collection type
 * @returns {JSX.Element} - Header component of the modal
 */
const ActionModalHeader = props => {
  const theme = useTheme();
  const style = useStyles(theme);
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const md = useMediaQuery(theme.breakpoints.down('md'));
  const clientSideEnv = getRunTimeEnv();

  return (
    <>
      {props.iconSrc && (
        <Box>
          <Image
            placeholder='blur'
            blurDataURL={BLUR_DATA_URL}
            width={82}
            height={82}
            src={`${clientSideEnv.NEXT_PUBLIC_STRAPI_SERVER || process.env.NEXT_PUBLIC_STRAPI_SERVER}${props.iconSrc}`}
            style={style.imgIconstyle}
            alt='ModalIcon'
            quality={sm || md ? 100 : 75}
          />
        </Box>
      )}
      {props.desktopImageSrc && props.mobileImageSrc && (
        <Box style={style.modalStyle}>
          <Image
            style={style.modalImage}
            placeholder='blur'
            blurDataURL={BLUR_DATA_URL}
            src={
              sm
                ? `${clientSideEnv.NEXT_PUBLIC_STRAPI_SERVER || process.env.NEXT_PUBLIC_STRAPI_SERVER}${props.mobileImageSrc}`
                : `${clientSideEnv.NEXT_PUBLIC_STRAPI_SERVER || process.env.NEXT_PUBLIC_STRAPI_SERVER}${props.desktopImageSrc}`
            }
            alt='ModalImage'
            layout='fill'
            quality={sm || md ? 100 : 75}
          />
        </Box>
      )}
    </>
  );
};

ActionModalHeader.displayName = 'ActionModalHeader';
export default ActionModalHeader;
